export const baseURL = process.env.REACT_APP_API_URL;

// Brand domain and links (from env; fallback for dev without env)
const brandDomain = process.env.REACT_APP_BRAND_DOMAIN || "lappa.org";
export const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || `support@${brandDomain}`;
export const infoEmail = process.env.REACT_APP_INFO_EMAIL || `info@${brandDomain}`;
export const developersBaseUrl = process.env.REACT_APP_DEVELOPERS_BASE_URL || `https://developers.${brandDomain}`;
export const merchantBaseUrl = process.env.REACT_APP_MERCHANT_BASE_URL || `https://merchant.${brandDomain}`;
export const cancellationPolicyUrl = `https://${brandDomain}/cancellation-and-refund-policy`;
export const privacyPolicyPath = `/files/Privacy Policy of website ${brandDomain}.pdf`;
export const termsOfUsePath = `/files/Terms of use of website ${brandDomain}.pdf`;
